export interface AppConfig {
  REACT_APP_BUILD_VERSION?: string;
  PUBLIC_URL?: string;
  REACT_APP_API_ROOT?: string;
  REACT_APP_CRAWLER_BUCKET?: string;
  REACT_APP_ARTIFACT_BUCKET?: string;
  REACT_APP_ASSET_BUCKET?: string;
  REACT_APP_GOOGLE_RECAPTCHA_SITE_KEY?: string;
  REACT_APP_STRIPE_KEY?: string;
  REACT_APP_STRIPE_ESSENTIAL_PRICE_ID?: string;
  REACT_APP_STRIPE_PREMIUM_PRICE_ID?: string;
  REACT_APP_STRIPE_PLATINUM_PRICE_ID?: string;
  REACT_APP_STRIPE_PLATINUM_AGGREGATOR_PRICE_ID?: string;
  KEYCLOAK_ISSUER?: string;
  KEYCLOAK_CLIENT_ID?: string;
  KEYCLOAK_AUTH_ENABLED?: boolean;
  // ci/env.sh emits every value as a JSON string, so AUTH_ENABLED is string here (parsed via parseFlag).
  REACT_APP_KEYCLOAK_ISSUER?: string;
  REACT_APP_KEYCLOAK_CLIENT_ID?: string;
  REACT_APP_KEYCLOAK_AUTH_ENABLED?: string;
  [key: string]: string | boolean | undefined;
}

// Initial default config (can be populated with build-time process.env if needed as fallback)
const _config: AppConfig = {
  KEYCLOAK_ISSUER: '',
  KEYCLOAK_CLIENT_ID: '',
  KEYCLOAK_AUTH_ENABLED: false,
  ...process.env,
};

export const runtimeConfig: Partial<AppConfig> = {};

export const config = _config;

export const loadConfig = async (): Promise<void> => {
  try {
    // Determine the path to config.json
    // If PUBLIC_URL is set at build time, we can use it, or just use relative path
    const configPath = `${process.env.PUBLIC_URL || ''}/config.json`;
    
    const response = await fetch(configPath);
    if (!response.ok) {
      console.warn(`Failed to load config.json: ${response.statusText}`);
      return;
    }

    const loadedRuntimeConfig = await response.json();
    
    // Merge runtime config into the exported config object
    // We assign to the existing object to preserve the reference
    Object.assign(runtimeConfig, loadedRuntimeConfig);
    Object.assign(_config, loadedRuntimeConfig);
    
    console.debug('Runtime config loaded:', loadedRuntimeConfig);
  } catch (error) {
    console.warn('Failed to fetch config.json', error);
  }
};
